export const newsList = [
  {
    id: "news-01",
    title: "《年轻的母亲2》口碑走高：一场关于“年轻母亲”的集体共鸣",
    date: "2024-05-08",
    category: "剧集动态",
    summary:
      "开播以来，该剧凭借对年轻母亲处境的细腻刻画持续引发讨论，社交平台上“看见妈妈的名字”话题阅读量不断攀升。",
    content: [
      "《年轻的母亲2》自开播以来，口碑稳步走高。与许多追求强冲突的家庭剧不同，它把镜头对准了那些被日常淹没的瞬间：洗碗时的独自落泪、加班错过的生日、雨夜里的长谈。正是这些不喧哗的细节，让“年轻母亲”这个群体被真正看见。",
      "剧中林慧的成长线被观众反复讨论。她不是完美的女性，会退让、会犹豫、会在深夜自我怀疑，但也正因如此，她的每一次向前都显得格外真实。有观众留言说，看到林慧第一次在餐桌上摊开设计稿的那一刻，自己也想去捡起搁置多年的东西。",
      "业内评论认为，该剧的价值不在于给出标准答案，而在于把“母亲也是一个人”这件事说得足够坦诚。它没有把家庭矛盾简化为善恶对立，而是让每个角色都带着自己的来处与伤痕，这也正是它能持续打动人的原因。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20tv%20drama%20still%2C%20warm%20kitchen%20scene%20at%20dusk%20with%20woman%20looking%20at%20design%20sketches%20on%20table%2C%20soft%20golden%20light%2C%20quiet%20reflective%20mood%2C%20film%20grain&width=800&height=450&seq=ym2-news01&orientation=landscape",
  },
  {
    id: "news-02",
    title: "主创访谈：如何让“婆媳线”摆脱套路",
    date: "2024-05-05",
    category: "幕后花絮",
    summary:
      "导演与编剧分享创作思路，坦言最难的是让每一场争执都“有来处”，避免把任何一方写成脸谱化的坏人。",
    content: [
      "在被问及如何看待“婆媳剧”这个标签时，主创团队表示，他们从一开始就不想拍一部靠吵架推动的剧。“我们想写的是两个被生活塑造过的女人，如何在同一屋檐下慢慢靠近。”导演在访谈中说。",
      "编剧提到，雨夜和解那场戏改了七稿。最初的版本里两人有很多台词，后来全部删掉，只留下蜡烛、雨声和一碗热粥。“有时候不说，比说更接近真实。”",
      "团队还透露，剧中大量细节来自真实的家庭观察，比如冰箱上贴的孩子画、幼儿园走廊里家长欲言又止的表情。这些看似微小的元素，构成了全剧的可信度。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20behind%20the%20scenes%20still%2C%20film%20director%20and%20screenwriter%20in%20discussion%20at%20table%20with%20scripts%2C%20warm%20studio%20light%2C%20creative%20collaborative%20mood%2C%20film%20grain&width=800&height=450&seq=ym2-news02&orientation=landscape",
  },
  {
    id: "news-03",
    title: "角色研究：王秀兰为什么不是“恶婆婆”",
    date: "2024-04-29",
    category: "角色分析",
    summary:
      "从半生辛酸到雨夜和解，本文梳理王秀兰这一角色的塑造逻辑，探讨她如何成为全剧最立体的配角。",
    content: [
      "在剧集初期，王秀兰几乎是观众吐槽的集中对象：挑剔、越界、说话带刺。但随着剧情深入，关于她的评价迅速反转。这种反转并非刻意洗白，而是角色本身足够饱满。",
      "关键在于，剧集给了她来处。独自拉扯儿女的岁月、与丈夫沉默的婚姻、那份藏在贴身口袋里的药瓶，这些信息被一点一点释放出来，让观众意识到她的强势其实是害怕被需要之外的自己毫无价值。",
      "从叙事角度看，王秀兰的存在让这部剧避免了简单化的代际对立。她与林慧的和解不是一方低头，而是两个女人终于看见了彼此。这种处理方式，也为同类题材提供了新的样本。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20tv%20drama%20still%2C%20elderly%20chinese%20woman%20looking%20out%20of%20window%20at%20old%20residential%20alley%2C%20soft%20afternoon%20light%2C%20nostalgic%20contemplative%20mood%2C%20film%20grain&width=800&height=450&seq=ym2-news03&orientation=landscape",
  },
  {
    id: "news-04",
    title: "美术设计解析：老城区空间里的生活质感",
    date: "2024-04-25",
    category: "幕后花絮",
    summary:
      "从斑驳的楼道到阳台的绿植，美术团队分享如何用空间细节，讲述一个普通家庭的真实日常。",
    content: [
      "该剧大量场景取自老城区居民楼，而非搭建的摄影棚。美术团队表示，他们希望空间本身就带着时间的痕迹。“斑驳的墙面、被磨亮的楼梯扶手，这些是演不出来的。”",
      "色调上，全剧以暖灰与旧木色为基底，只在关键情绪节点引入暖橙色光源，比如烛光、便利店灯牌、清晨的窗光。色彩因此承担了叙事功能，而不是单纯的装饰。",
      "值得一提的是阳台那盆贯穿多集的绿植。它从搬入时的蔫头耷脑，到结局时的枝繁叶茂，成为这个家庭状态变化的无声注脚。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20art%20department%20still%2C%20old%20chinese%20residential%20building%20alley%20with%20worn%20walls%20and%20green%20plants%20on%20balcony%2C%20warm%20late%20afternoon%20light%2C%20textured%20nostalgic%20mood%2C%20film%20grain&width=800&height=450&seq=ym2-news04&orientation=landscape",
  },
  {
    id: "news-05",
    title: "观众票选：最受欢迎的五场戏",
    date: "2024-04-20",
    category: "观众互动",
    summary:
      "从雨夜和解到拼图之夜，我们整理了观众讨论度最高、反复回看的五个名场面，并附上剧情回顾。",
    content: [
      "第五场：第二集的冰箱贴画。一张孩子画的三个人，让剑拔弩张的夫妻第一次沉默。简单的画面，胜过千言万语。",
      "第四场：第七集的融化蛋糕。林慧深夜赶回，剩下的只有融化的奶油和一根没吹灭的蜡烛。无数观众表示看到这里破防。",
      "第三场：第九集的关东煮。两个职场对手在便利店门口第一次聊起各自的母亲，竞争之下透出理解。",
      "第二场：第十集的雨夜和解。没有拥抱，没有台词堆砌，只有一碗热粥和一句“以后别硬撑”，却成了全剧口碑最高的场景。",
      "第一场：第十五集的拼图之夜。缺的那一块，晓彤说“没关系，我们自己画”。这句话被做成无数个截图，成为全剧最被记住的台词。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20tv%20drama%20still%2C%20jigsaw%20puzzle%20with%20one%20missing%20piece%20on%20living%20room%20floor%20at%20night%2C%20warm%20lamp%20glow%2C%20intimate%20emotional%20mood%2C%20film%20grain&width=800&height=450&seq=ym2-news05&orientation=landscape",
  },
  {
    id: "news-06",
    title: "第一季收官：留白的结局与未讲完的故事",
    date: "2024-05-02",
    category: "剧集动态",
    summary:
      "大结局没有大团圆，也没有煽情告别。本文解读这个“留白式”收尾背后的创作考量，以及可能的后续方向。",
    content: [
      "《年轻的母亲2》第一季以林慧工作室开张、婆婆在阳台种下第一盆花作结。没有盛大的婚礼，没有久别重逢，镜头只是缓缓拉远，老楼的灯一盏盏亮起。",
      "主创表示，他们刻意避开了传统意义上的“大结局”。“生活不会在某一天突然圆满，它只是继续向前。我们想让观众记住的，是那种‘日子还能这样过下去’的感觉。”",
      "关于是否会有后续，团队表示故事的确还有可以延展的空间，尤其是赵建国往事留下的余韵，以及李静与高铭之间若隐若现的线索。但一切仍言之尚早。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20tv%20drama%20still%2C%20old%20residential%20building%20at%20dusk%20with%20warm%20glowing%20windows%20one%20by%20one%2C%20deep%20blue%20evening%20sky%2C%20quiet%20hopeful%20ending%20mood%2C%20film%20grain&width=800&height=450&seq=ym2-news06&orientation=landscape",
  },
];